import FlashLib from "flashlib";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";

export default class BackgroundMobileContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.init();
        this.changeState(1);
    }

    init() {
        GlobalDispatcher.add('scaleManager:resize', this.onGameResized, this);
    }

    onGameResized(event) {
        //this.width = Math.max(event.params.canvasWidth, event.params.canvasHeight);
        //this.height = Math.max(event.params.canvasWidth, event.params.canvasHeight);

        let scale = Math.max(event.params.canvasWidth, event.params.canvasHeight) / 1920;
        this.scale.set(scale, scale);
        this.y = event.params.canvasHeight / 2;
    }

    changeState(value) {
        this.goToFrame(value);
    }
}